module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-cocoa-007-1200x2490.b8d3cb7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-cocoa-007-1200x2490.jpg
// module id = 1091
// module chunks = 37